module.exports = __webpack_public_path__ + "img/they-live.26d59537.gif";